<ion-header class="transparent absolute">
    <app-header [middleIcon]="false" [hide930]="true"></app-header>
</ion-header>
<div class="blue-bg" [ngClass]="'bg-inner-'+userService.theme">
    <div class="content-wrap-inner">
        <img class="side-logo" [src]="userService.companyLogo">
        <div class="title my-color-blue" [@enter]>{{'__COACHING_TITLE__' | translate}}</div>

        <div class="text-large" [@enter]>{{'__COACHING_SUBTITLE__' | translate}}</div>
        <div class="text text1" [@enter]>{{'__COACHING_DESRIPTION1__' | translate}}</div>
        <div class="text text2" [@enter]>{{'__COACHING_DESRIPTION2__' | translate}}</div>

        <ng-container *ngIf="managers !== null && roles !== null">
            <div class="label" [@enter]>{{'__COACHING_TEAM_DESC__' | translate}}</div>
<!--            <ion-select class="My-select" [interface]="'popover'" [(ngModel)]="managerId" (ionChange)="selectFilter()">-->
<!--                <ion-select-option [value]="0">{{'__COACHING_SELECT_TEAM__' | translate}}</ion-select-option>-->

<!--                <ion-select-option *ngFor="let manager of managers" [value]="manager.id">-->
<!--                    {{manager.full_name}}-->
<!--                </ion-select-option>-->
<!--            </ion-select>-->

            <ng-select class="My-dropdown" [(ngModel)]="managerId" (ngModelChange)="selectFilter()"
                       [searchable]="false" [clearable]="false">
                <ng-option [value]="0">{{'__COACHING_SELECT_TEAM__' | translate}}</ng-option>
                <ng-option *ngFor="let manager of managers" [value]="manager.id">
                    {{manager.full_name}}
                </ng-option>
            </ng-select>


            <div class="label" [@enter]>{{'__COACHING_ROLE_DESC__' | translate}}</div>
<!--            <ion-select class="My-select" [interface]="'popover'" [(ngModel)]="roleId" (ionChange)="selectFilter()">-->
<!--                <ion-select-option [value]="0">{{'__COACHING_SELECT_ROLE__' | translate}}</ion-select-option>-->
<!--                <ion-select-option *ngFor="let role of roles" [value]="role.id">-->
<!--                    {{role.title}}-->
<!--                </ion-select-option>-->
<!--            </ion-select>-->

            <ng-select class="My-dropdown" [(ngModel)]="roleId" (ngModelChange)="selectFilter()"
                       [searchable]="false" [clearable]="false">
                <ng-option [value]="0">{{'__COACHING_SELECT_ROLE__' | translate}}</ng-option>
                <ng-option *ngFor="let role of roles" [value]="role.id">
                    {{role.title}}
                </ng-option>
            </ng-select>
        </ng-container>
    </div>
</div>

<div class="coaching-wrap content-wrap" *ngIf="coachingList !== null">
    <div class="data-box"
         *ngFor="let item of coachingList; let i = index;"
         [@leave]>

        <div class="icon-user">
            <img src="assets/img/comments.svg" *ngIf="item.reports.details.length > 0" (click)="openCoachingComments(item.delegate.id)" alt="user">
            <img src="assets/img/comments-grey.svg" *ngIf="item.reports.details.length === 0" alt="user" class="disabled">
        </div>
        <div class="icon-plus" (click)="newCoachingReport(item.delegate.id)">
            <img *ngIf="false" src="assets/img/plus.svg" class="disabled" alt="plus">
            <img *ngIf="true" src="assets/img/plus-active.svg" alt="plus">
        </div>

        <div class="title">{{item.delegate.full_name}}</div>
        <div class="my-color-blue title-small" *ngIf="item.delegate.role !== null">
            {{item.delegate.role.title}}</div>

        <div class="text-line">
            <div>&#9668; {{'__COACHING_OLDEST__' | translate}}</div>
            <div>{{'__COACHING_LATEST__' | translate}} &#9658;</div>
            <div>{{'__COACHING_AVERAGE__' | translate}}</div>
        </div>

        <div class="items">
            <div class="coaching-value-list">
                <div class="item" *ngFor="let i of [0, 1, 2, 3, 4, 5]">
                    <ng-container *ngIf="item.reports.details[i]">
                        <div class="number"
                             [ngClass]="item.reports.details[i].average.average.output.style.class"
                             (click)="openCoachingReport(item.reports.details[i].id, item.delegate.id)">
                            {{item.reports.details[i].average.average.output.value}}
                        </div>
                        <div class="date">{{item.reports.details[i].date.output.short}}</div>
                    </ng-container>
                </div>
            </div>
            <div class="item">
                <div class="number" [ngClass]="item.reports.average.average.output.style.class">
                    {{item.reports.average.average.output.value}}
                </div>
            </div>
        </div>
    </div>

</div>

<div class="coaching-wrap content-wrap" *ngIf="coachingList === null">
    <app-skeleton-list></app-skeleton-list>
</div>
